"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _context = require("../context");
var _navigation = require("../context/navigation");
var _sponsorContext = require("../context/sponsorContext");
var _utils = require("../utils");
var _ApiProvider = require("./ApiProvider");
// istanbul ignore file -- constant file

const Context = exports.Context = (0, _utils.composeProviders)(_ApiProvider.ApiProvider, _presentationHttp.UserSegmentationDataProvider, _context.HeadersProvider, _context.AppPromoProvider, _navigation.SearchInputProvider, _navigation.ActiveLinkProvider, _navigation.ActiveMenuProvider, _context.ConsultantProvider, _context.TopAreaBannerProvider, _navigation.LabelsProvider, _navigation.BurgerMenuProvider, _sponsorContext.SponsorContextProvider);
